<template>
  <div>
    <v-card
      v-if="linhas"
      outlined
      class="app-card"
    >
      <v-card-title class="app-card-title">
        Pesquisa de Linhas
      </v-card-title>
      <v-card-text class="app-card-content">
        <v-row>
          <v-col
            :md="6"
            :sm="6"
            :xs="12"
            cols="12"
          >
            <h3 class="location-title">
              Origem:
              <v-icon>location_on</v-icon>
              {{ origem }}
            </h3>
          </v-col>
          <v-col
            :md="6"
            :sm="6"
            :xs="12"
            cols="12"
          >
            <h3 class="location-title">
              Destino:
              <v-icon>location_on</v-icon>
              {{ destino }}
            </h3>
          </v-col>
          <v-col
            :md="12"
            :sm="12"
            :xs="12"
            cols="12"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Linha
                    </th>
                    <th class="text-left">
                      Empresa
                    </th>
                    <th class="text-left">
                      Descrição
                    </th>
                    <th class="text-left">
                      Espécie
                    </th>
                    <th
                      class="text-left"
                      width="90px"
                    >
                      Tarifa
                    </th>
                    <th class="text-left">
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(linha, index) in linhas"
                    :key="index"
                  >
                    <td class="pt-2 pb-2">
                      {{ linha.codigo }}
                    </td>
                    <td class="pt-2 pb-2">
                      {{ linha.transportadora }}
                    </td>
                    <td class="pt-2 pb-2">
                      {{ linha.nome }}
                    </td>
                    <td class="pt-2 pb-2">
                      {{ linha.servico }}
                    </td>
                    <td class="pt-2 pb-2">
                      {{ linha.tarifa | currency }}
                    </td>
                    <td class="pt-2 pb-2">
                      <v-btn
                        v-if="linha.temHorario"
                        icon
                        :title="
                          `Clique aqui para ver os horários dessa linha ${linha.nome}`
                        "
                        @click="seeHours(linha.id)"
                      >
                        <v-icon>date_range</v-icon>
                      </v-btn>
                      <v-chip
                        v-else
                        color="orange"
                        text-color="white"
                      >
                        Linha Paralizada
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog"
      width="900"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Horários de {{ origem }} para {{ destino }}
        </v-card-title>

        <v-card-text>
          <br>
          <h3 class="location-title">
            Saindo de {{ origem }}
          </h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="horario in horariosOrigem"
                    :key="`${horario.name}-th-origem`"
                    class="text-left"
                    v-text="horario.name"
                  />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    v-for="horario in horariosOrigem"
                    :key="`${horario.name}-td-origem`"
                  >
                    <tr
                      v-for="hour in horario.hours"
                      :key="`${hour.hour}-row-origem`"
                    >
                      <td v-text="hour.hour" />
                    </tr>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <br>
          <h3 class="location-title">
            Saindo de {{ destino }}
          </h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="horario in horariosDestino"
                    :key="`${horario.name}-th`"
                    class="text-left"
                    v-text="horario.name"
                  />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    v-for="horario in horariosDestino"
                    :key="`${horario.name}-td`"
                  >
                    <tr
                      v-for="hour in horario.hours"
                      :key="`${hour.hour}-row`"
                    >
                      <td v-text="hour.hour" />
                    </tr>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            color="error"
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HorarioService from "@/services/horario.service";
import { uniqBy } from 'lodash'

export default {
  props: {
    linhas: Array
  },
  data() {
    return {
      origem: null,
      destino: null,
      dialog: false,
      horarios: null,
      horariosOrigem: null,
      horariosDestino: null
    };
  },
  watch: {
    linhas: function(newLinhas, oldLinhas) {
      this.origem = newLinhas[0].origem;
      this.destino = newLinhas[0].destino;
    }
  },
  mounted() {
    this.origem = this.linhas[0].origem;
    this.destino = this.linhas[0].destino;
  },
  methods: {
    seeHours(codigo) {
      this.dialog = true;
      HorarioService.findBy(codigo).subscribe(
        response => {
          this.horarios = response;
          this.filtraHorariosOrigem();
          this.filtraHorariosDestino();
        },
        error => {}
      );
    },
    filtraHorariosOrigem() {
       this.horariosOrigem = uniqBy(this.horarios, 'nome').map(day=>{
        const name  = day.nome
        const hours = this.horarios
                        .filter(h => h.origem === this.origem && h.nome === name)
                        .map(h=>({day: h.nome, hour: h.horaSaida, from: h.origem }))

        return {name, hours}
      })
    },
    filtraHorariosDestino() {
      this.horariosDestino = uniqBy(this.horarios, 'nome').map(day=>{
        const name  = day.nome
        const hours = this.horarios
                        .filter(h => h.origem === this.destino && h.nome === name)
                        .map(h=>({day: h.nome, hour: h.horaSaida, from: h.origem }))

        return {name, hours}
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.location-title {
  margin: 0px;
  font-size: 16px !important;
  text-transform: uppercase;
  text-align: center;
  color: #000;
  font-weight: 400 !important;
}
</style>
